import {InformationLinkButtonFieldsFragment} from '@generated/graphql';
import {hasLinkAndLabel} from '@/lib/type-guards';

export type InformationLinkButtonWithLinkAndLabel = InformationLinkButtonFieldsFragment & {
    link: string;
    label: string
}

export const informationButtonLinkHasLinkAndLabel = (link: InformationLinkButtonFieldsFragment | null | undefined): link is InformationLinkButtonWithLinkAndLabel => {
  return hasLinkAndLabel(link);
}

// A single section inside a LinkButton's modalSections collection.
export type ModalSectionItem = NonNullable<
  NonNullable<InformationLinkButtonFieldsFragment['modalSectionsCollection']>['items'][number]
>;

// A button that has a label and is therefore renderable. The link is optional
// because a button may instead open a modal of sections.
export type RenderableLinkButton = InformationLinkButtonFieldsFragment & {
    label: string;
}

// True when the button has at least one non-null section to show in a modal.
export const buttonHasModalSections = (
  button: InformationLinkButtonFieldsFragment | null | undefined
): boolean => {
  return !!button?.modalSectionsCollection?.items.some(Boolean);
}

// A button is renderable when it has a label and either a link to navigate to
// or modal sections to open. Modal sections take precedence over the link.
export const isRenderableLinkButton = (
  button: InformationLinkButtonFieldsFragment | null | undefined
): button is RenderableLinkButton => {
  return !!button?.label && (!!button.link || buttonHasModalSections(button));
}
